<template>
  <div>
    <Organization :v="v" />
    <Assignee
      :v="v.assignee"
      label="Сведения о представителе юридического лица"
    />
  </div>
</template>

<script>
import cloneDeep from 'clone-deep';
import Assignee, {
  getAssigneeValidation,
  assigneeModel,
  prefillEsiaAssignee,
} from '@/components/services/EgrnConfirm/Applicant/components/Assignee';
import Organization, {
  organizationModel,
  organizationValidation,
  prefillEsiaOrg,
} from '@/components/services/EgrnConfirm/Applicant/components/Organization';

export const mrpaEnableAssigneeOrganizationModel = {
  ...organizationModel,
  assignee: cloneDeep(assigneeModel),
};

export const getMrpaEnableAssigneeOrganizationValidation = (organization) => ({
  ...organizationValidation,
  assignee: getAssigneeValidation(organization.assignee),
});

export const prefillEsiaMrpaEnableAssigneeOrganization = async () => {
  const esiaOrg = await prefillEsiaOrg();

  return cloneDeep({
    ...mrpaEnableAssigneeOrganizationModel,
    ...esiaOrg,
    assignee: await prefillEsiaAssignee(),
  });
};

export default {
  name: 'MrpaEnableAssigneeOrganization',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    Organization,
    Assignee,
  },
};
</script>
